import { Flex, Image } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { getSentCards } from 'src/legacy_graphql'
import { useQueries } from 'src/hooks'

export const CardHistoryGrid: React.FC = () => {
  const [cardHistory] = useQueries(
    getSentCards({
      page: 1,
      search: '',
      contacts: [],
    }),
  )

  const cards = cardHistory?.results.slice(0, 4).map(res => {
    const card = res?.recipient?.card
    return {
      preview: card?.frontPreviewUrl,
      isHorizontal: card?.isHorizontal,
    }
  })

  const previews = cards.map((card, index) => (
    <Image
      key={index}
      borderRadius="default"
      height={!card.isHorizontal ? '120px' : '90px'}
      width={!card.isHorizontal ? '90px' : '120px'}
      image={{ url: card.preview ?? '' }}
      isActive={false}
    />
  ))

  const [first, second, third, fourth] = previews
  return (
    <Flex
      height="300px"
      width="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Flex justifyContent="center" alignItems="center">
        {first}
        {second}
      </Flex>
      <Flex justifyContent="center" alignItems="center">
        {third}
        {fourth}
      </Flex>
    </Flex>
  )
}
